import { Right } from "@/type/core/offices/offices.types";
import BasicButton from "@components/core/buttons/BasicButton";
import InfoModal from "@components/core/modals/InfoModal";
import {
  TransactionDetail,
  TransactionStatus,
} from "@type/core/transaction/transaction.types";
import { FunctionComponent } from "react";

interface TransactionPrepareButtonProps {
  transaction: TransactionDetail;
  onClick: (status: TransactionStatus, cause: string) => void;
  officeRights?: Right[];
  signatureRight: Right;
  scellementRight: Right;
  label: string;
  className?: string;
  disabled?: boolean;
}

const TransactionPrepareButton: FunctionComponent<
  TransactionPrepareButtonProps
> = ({
  transaction,
  onClick,
  officeRights,
  signatureRight,
  scellementRight,
  label,
  className = "",
  disabled = false,
}) => {
  const signatureType = transaction && transaction.type === "signature";
  const scellementType = transaction && transaction.type === "scellement";

  if (
    (signatureType && officeRights?.includes(signatureRight)) ||
    (scellementType && officeRights?.includes(scellementRight))
  ) {
    return (
      <div className="d-flex align-items-center gap-4">
        <BasicButton
          disabled={disabled}
          variant="tertiary"
          text={label}
          onClick={() => onClick("prepared", "")}
          className={`py-11 px-30 font-extra-small ${className}`}
        />
        <InfoModal value="prepared" info />
      </div>
    );
  } else return null;
};

export default TransactionPrepareButton;
